/* BXYZ:..:eliot@bosmanxyz.xyz:..:.www.bosmanxyz.xyz */
(function() {
  if (typeof LocomotiveScroll === 'undefined') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const scrollTillstand = { instans: null };
  const ankarOffset = -80;

  function hamtaScrollToken(namn, fallback) {
    const varde = getComputedStyle(document.documentElement).getPropertyValue(namn).trim();
    return varde || fallback;
  }

  function hamtaScrollSekunder(token, fallbackMs) {
    const rå = hamtaScrollToken(token, fallbackMs + 'ms');
    return (parseFloat(rå) || fallbackMs) / 1000;
  }

  function hamtaScrollLerp() {
    return parseFloat(hamtaScrollToken('--anim-scroll-lerp', '0.38')) || 0.38;
  }

  function forhindrarScroll(node) {
    return !!node.closest('[data-scroll-forhindra],[data-lenis-prevent]');
  }

  function hamtaSidaSlut() {
    return document.querySelector('[data-sida-slut]');
  }

  function hamtaScrollTak() {
    const slut = hamtaSidaSlut();
    if (!slut) return null;
    const vh = window.innerHeight;
    const top = slut.offsetTop;
    const h = slut.offsetHeight;
    if (window.matchMedia('(min-width: 64.0625rem)').matches && h <= vh * 1.08) {
      return Math.max(0, top + h / 2 - vh / 2);
    }
    return Math.max(0, top + h - vh);
  }

  function klampScroll() {
    const instans = scrollTillstand.instans;
    const tak = hamtaScrollTak();
    if (!instans || tak == null || !instans.lenisInstance) return;
    if (instans.lenisInstance.scroll > tak + 1) {
      instans.lenisInstance.scrollTo(tak, { immediate: true });
    }
  }

  function hamtaScrollUppVaraktighet() {
    const lenis = scrollTillstand.instans?.lenisInstance;
    const nu = lenis?.scroll ?? lenis?.animatedScroll ?? window.scrollY ?? 0;
    const bas = hamtaScrollSekunder('--anim-scroll-varaktighet', 720);
    const vh = Math.max(window.innerHeight, 1);
    return Math.min(bas * 3.2, bas * (0.9 + (nu / vh) * 0.75));
  }

  function scrollaTillMal(mal, offset, duration) {
    if (!scrollTillstand.instans) return;
    if (mal === 0 || mal === '0') {
      scrollTillstand.instans.scrollTo(0, {
        duration: duration ?? hamtaScrollUppVaraktighet(),
        easing: (t) => 1 - Math.pow(1 - t, 4)
      });
      return;
    }
    if (!mal) return;
    scrollTillstand.instans.scrollTo(mal, {
      offset: offset ?? ankarOffset,
      duration: duration ?? hamtaScrollSekunder('--anim-scroll-varaktighet-kort', 420),
      easing: (t) => 1 - Math.pow(1 - t, 4)
    });
  }

  function uppdateraScrollTillstand(values) {
    const progress = values?.progress ?? 0;
    const velocity = Math.abs(values?.velocity ?? 0);
    const scroll = values?.scroll ?? 0;
    document.documentElement.style.setProperty('--scroll-progress', String(progress));
    document.documentElement.dataset.scrollProgress = progress <= 0.01 ? 'start' : progress >= 0.99 ? 'slut' : 'mitten';
    document.documentElement.dataset.scrollRorelse = velocity > 0.05 ? 'aktiv' : 'vila';
    document.dispatchEvent(new CustomEvent('bxyz:scroll', { detail: { scroll, velocity, progress } }));
    klampScroll();
  }

  function registreraAnimateIn() {
    document.querySelectorAll('.animate-in:not([data-scroll])').forEach(function(el) {
      el.setAttribute('data-scroll', '');
      el.setAttribute('data-scroll-class', hamtaScrollToken('--anim-scroll-klass', 'is-inview').replace(/^\./, ''));
    });
  }

  function hanteraScrollBegaran(event) {
    const detail = event.detail || {};
    const mal = typeof detail.target === 'string' ? document.querySelector(detail.target) : detail.target;
    scrollaTillMal(mal, detail.offset, detail.duration);
  }

  function hanteraAnkarKlick(event) {
    const lank = event.target.closest('a[href^="#"]');
    if (!lank) return;
    const href = lank.getAttribute('href');
    if (!href || href === '#') return;
    const mal = document.querySelector(href);
    if (!mal) return;
    event.preventDefault();
    scrollaTillMal(mal, ankarOffset);
  }

  function initiera() {
    if (scrollTillstand.instans) return;
    registreraAnimateIn();
    const instans = new LocomotiveScroll({
      lenisOptions: {
        lerp: hamtaScrollLerp(),
        duration: hamtaScrollSekunder('--anim-scroll-varaktighet-kort', 420),
        smoothWheel: false,
        syncTouch: false,
        prevent: forhindrarScroll
      },
      scrollCallback: uppdateraScrollTillstand
    });
    scrollTillstand.instans = instans;
    document.documentElement.dataset.scroll = 'locomotive';
    document.documentElement.dataset.scrollProgress = 'start';
    document.documentElement.dataset.scrollRorelse = 'vila';
    klampScroll();

    document.addEventListener('bxyz:scrollto', hanteraScrollBegaran);
    document.addEventListener('click', hanteraAnkarKlick, true);
    document.addEventListener('shopify:section:load', function(event) {
      registreraAnimateIn();
      if (event.target instanceof HTMLElement) instans.addScrollElements(event.target);
      instans.resize();
      klampScroll();
    });
    document.addEventListener('shopify:section:unload', function(event) {
      if (event.target instanceof HTMLElement) instans.removeScrollElements(event.target);
      instans.resize();
      klampScroll();
    });
    window.addEventListener('resize', function() {
      instans.resize();
      klampScroll();
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initiera, { once: true });
  } else {
    initiera();
  }
})();
